





























import { Component, Vue } from 'vue-property-decorator';
import dayjs from 'dayjs';
import authModule from '@/store/Auth';
import wordpressModule from '@/store/Wordpress';
import { OrganisationUser } from '@/api';
import { OrganisationUserRole } from '@/api/models/OrganisationUser';

@Component({})
export default class TermsAndConditionsBanner extends Vue {
  owners: OrganisationUser[] = [];

  showBanner = false;

  get latestTermsDate() {
    return wordpressModule.latestTermsDate;
  }

  get gracePeriodEnd() {
    return wordpressModule.gracePeriodEnd;
  }

  get isGracePeriod() {
    return wordpressModule.isGracePeriod;
  }

  get isOwner() {
    return authModule.isOwner;
  }

  async getOwners() {
    if (!authModule.activeOrganisation) {
      return;
    }
    const owners = (
      await OrganisationUser.includes('user')
        .where({
          organisation: authModule.activeOrganisation.organisation.id,
          role: OrganisationUserRole.Owner,
        })
        .all()
    ).data;
    this.owners = owners;
  }

  get hasAgreement() {
    return this.owners.some((ou: OrganisationUser) => {
      if (!this.latestTermsDate) {
        return true;
      }

      const { user } = ou;
      return (
        !!user.agreeTcAt && dayjs(user.agreeTcAt).isAfter(this.latestTermsDate)
      );
    });
  }

  setShowBanner() {
    if (!authModule.activeOrganisation) {
      this.showBanner = false;
    }

    this.showBanner =
      !authModule.isTrainingSession &&
      !!this.latestTermsDate &&
      !!this.gracePeriodEnd &&
      this.isGracePeriod &&
      !this.isOwner &&
      this.owners &&
      !this.hasAgreement;
  }

  async beforeMount() {
    await this.getOwners();
    this.setShowBanner();
  }
}
